import { CustomCellRendererProps } from "@ag-grid-community/react";
import TransactionID from "shared/components/DS/TransactionID";

const TransactionIDRenderer = (params: CustomCellRendererProps) => (
  <TransactionID value={params.value}/>
)

export default TransactionIDRenderer;
